import styled from "styled-components";
import Chip from "@mui/material/Chip";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import { fontSizes } from "healthex-common/sizes";
const BaseChip = styled(Chip).attrs({ variant: "outlined", size: "medium" }) `
    height: 24px;
    font-weight: ${fontWeights.SEMI_BOLD};
    border-radius: 4px;
    text-transform: uppercase;
    font-size: ${fontSizes.TINY};
    line-height: normal;
    letter-spacing: 0.14px;

    & .MuiChip-label {
        padding: 0 8px;
    }
`;
export const RedwoodChip = styled(BaseChip) `
    color: ${colors.chips_redwood};
    border-color: ${colors.chips_redwood};
    background: ${colors.chips_redwood_10};
`;
export const NeptuneChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_neptune};
    border-color: ${colors.chips_neptune};
    background: ${colors.chips_neptune_10};
`;
export const EmberChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_ember};
    border-color: ${colors.chips_ember};
    background: ${colors.chips_ember_10};
`;
export const AzureChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_azure};
    border-color: ${colors.chips_azure};
    background: ${colors.chips_azure_10};
`;
export const SaffronChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_saffron};
    border-color: ${colors.chips_saffron};
    background: ${colors.chips_saffron_10};
`;
export const AmethystChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_amethyst};
    border-color: ${colors.chips_amethyst};
    background: ${colors.chips_amethyst_10};
`;
export const ForestChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_forest};
    border-color: ${colors.chips_forest};
    background: ${colors.chips_forest_10};
`;
export const TulipChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_tulip};
    border-color: ${colors.chips_tulip};
    background: ${colors.chips_tulip_10};
`;
export const SlateChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_slate};
    border-color: ${colors.chips_slate};
    background: ${colors.chips_slate_10};
`;
export const TangerineChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_tangerine};
    border-color: ${colors.chips_tangerine};
    background: ${colors.chips_tangerine_10};
`;
export const ScarletChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_scarlet};
    border-color: ${colors.chips_scarlet};
    background: ${colors.chips_scarlet_10};
`;
